export default class RateCategory {
	constructor({ id, name, parent, event, order, modified, removed } = {}) {
		this.id = id;
		this.name = name;
		this.parent = parent;
		this.event = event;
		this.order = order;
		this.modified = modified;
		this.removed = removed;
	}

	static buildFromJSON(json) {
		return new RateCategory({
			id: json.id,
			name: json.name,
			parent: json.parent,
			event: json.event,
			order: json.order,
			modified: json.modified,
			removed: json.removed
		});
	}

	toJSON() {
		return {
			id: this.id,
			name: this.name,
			parent: this.parent,
			event: this.event,
			order: this.order,
			modified: this.modified,
			removed: this.removed
		};
	}

	getId() {
		return this.id;
	}

	getName() {
		return this.name;
	}

	getParent() {
		return this.parent;
	}

	getEvent() {
		return this.event;
	}

	getOrder() {
		return this.order;
	}
}
